import React from 'react';

import { useCallbackRef } from '@/js/libs/hooks/useCallbackRef/index.ts';

import { BaseComponent } from '../BaseComponent.tsx';
import type { IconBaseProps, IconRender } from '../types.ts';

const Past = React.forwardRef<SVGSVGElement | null, IconBaseProps>(function Past({ dataTestId, ...props }, ref) {
  const iconRender = useCallbackRef<IconRender>((color: string) => (
    <>
      <path
        d='M10 9.25C10.2761 9.25 10.5 9.02614 10.5 8.75V8.25C10.5 7.97386 10.2761 7.75 10 7.75H7C6.72386 7.75 6.5 7.97386 6.5 8.25V8.75C6.5 9.02614 6.72386 9.25 7 9.25H10Z'
        fill={color}
      />
      <path
        d='M9.5 11.75C9.77614 11.75 10 11.5261 10 11.25V10.75C10 10.4739 9.77614 10.25 9.5 10.25H7C6.72386 10.25 6.5 10.4739 6.5 10.75V11.25C6.5 11.5261 6.72386 11.75 7 11.75H9.5Z'
        fill={color}
      />
      <path
        d='M8.5 14.25C8.77614 14.25 9 14.0261 9 13.75V13.25C9 12.9739 8.77614 12.75 8.5 12.75H7C6.72386 12.75 6.5 12.9739 6.5 13.25V13.75C6.5 14.0261 6.72386 14.25 7 14.25H8.5Z'
        fill={color}
      />
      <path
        d='M9.5 16.75C9.77614 16.75 10 16.5261 10 16.25V15.75C10 15.4739 9.77614 15.25 9.5 15.25H7C6.72386 15.25 6.5 15.4739 6.5 15.75V16.25C6.5 16.5261 6.72386 16.75 7 16.75H9.5Z'
        fill={color}
      />
      <path
        d='M19 11.25C19 11.5261 18.7761 11.75 18.5 11.75H15.5C15.2239 11.75 15 11.5261 15 11.25V10.75C15 10.4739 15.2239 10.25 15.5 10.25H18.5C18.7761 10.25 19 10.4739 19 10.75V11.25Z'
        fill={color}
      />
      <path
        d='M19 13.75C19 14.0261 18.7761 14.25 18.5 14.25H15.5C15.2239 14.25 15 14.0261 15 13.75V13.25C15 12.9739 15.2239 12.75 15.5 12.75H18.5C18.7761 12.75 19 12.9739 19 13.25V13.75Z'
        fill={color}
      />
      <path
        d='M19 16.25C19 16.5261 18.7761 16.75 18.5 16.75H15.5C15.2239 16.75 15 16.5261 15 16.25V15.75C15 15.4739 15.2239 15.25 15.5 15.25H18.5C18.7761 15.25 19 15.4739 19 15.75V16.25Z'
        fill={color}
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M11.05 2.35C10.4278 1.88333 9.57222 1.88333 8.95 2.35L7.75 3.25H5C4.0335 3.25 3.25 4.0335 3.25 5V20C3.25 20.9665 4.0335 21.75 5 21.75H15C15.9665 21.75 16.75 20.9665 16.75 20V19.75H19C20.5188 19.75 21.75 18.5188 21.75 17V10.4142C21.75 9.95008 21.5656 9.50497 21.2374 9.17678L19.8232 7.76256C19.495 7.43437 19.0499 7.25 18.5858 7.25H16.75V5C16.75 4.0335 15.9665 3.25 15 3.25H12.25L11.05 2.35ZM9.85 3.55C9.93889 3.48333 10.0611 3.48333 10.15 3.55L11.25 4.375V5C11.25 5.13807 11.1381 5.25 11 5.25H9C8.86193 5.25 8.75 5.13807 8.75 5V4.375L9.85 3.55ZM12.75 4.75V5C12.75 5.9665 11.9665 6.75 11 6.75H9C8.0335 6.75 7.25 5.9665 7.25 5V4.75H5C4.86193 4.75 4.75 4.86193 4.75 5V20C4.75 20.1381 4.86193 20.25 5 20.25H15C15.1381 20.25 15.25 20.1381 15.25 20V19.75H14C13.0335 19.75 12.25 18.9665 12.25 18V10C12.25 8.48122 13.4812 7.25 15 7.25H15.25V5C15.25 4.86193 15.1381 4.75 15 4.75H12.75ZM14 18.25C13.8619 18.25 13.75 18.1381 13.75 18V10C13.75 9.30964 14.3096 8.75 15 8.75H18.5858C18.6521 8.75 18.7157 8.77634 18.7626 8.82322L20.1768 10.2374C20.2237 10.2843 20.25 10.3479 20.25 10.4142V17C20.25 17.6904 19.6904 18.25 19 18.25H14Z'
        fill={color}
      />
    </>
  ));
  return <BaseComponent ref={ref} dataTestId={dataTestId ?? 'past-icon-svg'} iconRender={iconRender} {...props} />;
});

export default Past;
